import { SWITCH_THEME } from "redux/types";

const switchTheme = () => ({ type: SWITCH_THEME });

export default switchTheme;
